import {formatDateToYyyyMmDd, TIME_FROM, TIME_TO} from "../utils/formattingUtils";

export const buildFilterFromUrl = () => {
    const searchParams = new URLSearchParams(window.location.search);
    const filterParam = searchParams.get('filter');
    const stored = sessionStorage.getItem('filter');
    const encoded = filterParam || stored;

    if (!encoded) return {};

    try {
        const parsed = JSON.parse(fromBase64(encoded));
        if (filterParam) {
            sessionStorage.setItem('filter', encoded);
        }
        return parsed;
    } catch (e) {
        return {};
    }
}

export const buildUrlFromFilter = (filter) => {
    const params = {}
    if (filter.dateFrom) {
        params.dateFrom = formatDateToYyyyMmDd(filter.dateFrom) + TIME_FROM
    }
    if (filter.dateTo) {
        params.dateTo = formatDateToYyyyMmDd(filter.dateTo) + TIME_TO
    }
    if (filter.selectedIntents?.length > 0) {
        params.selectedIntents = filter.selectedIntents
    }
    if (filter.selectedEntities?.length > 0) {
        params.selectedEntities = filter.selectedEntities
    }
    if (filter.selectedEntityValues?.length > 0) {
        params.selectedEntityValues = filter.selectedEntityValues
    }
    if (filter.selectedStatuses?.length > 0) {
        params.selectedStatuses = filter.selectedStatuses
    }
    if (filter.selectedFeelings?.length > 0) {
        params.selectedFeelings = filter.selectedFeelings
    }
    if (filter.selectedRatings?.length > 0) {
        params.selectedRatings = filter.selectedRatings
    }
    if (filter.inputSessionID) {
        params.inputSessionID = filter.inputSessionID
    }
    if (filter.selectedPlatforms?.length > 0) {
        params.selectedPlatforms = filter.selectedPlatforms
    }
    if (filter.selectedContext?.length > 0) {
        params.selectedContext = filter.selectedContext
    }
    if (filter.selectedContextValues?.length > 0) {
        params.selectedContextValues = filter.selectedContextValues
    }
    if (filter.scoreFrom && filter.scoreFrom > 0) {
        params.scoreFrom = filter.scoreFrom
    }
    if (filter.scoreTo && filter.scoreTo < 1) {
        params.scoreTo = filter.scoreTo
    }
    if (filter.fulltext) {
        params.fulltext = filter.fulltext
    }
    if (filter.aiFilter) {
        params.aiFilter = filter.aiFilter
    }
    if (filter.minimalAnswerCount && filter.minimalAnswerCount > 0) {
        params.minimalAnswerCount = filter.minimalAnswerCount
    }
    if (filter.category?.length > 0) {
        params.category = filter.category
    }
    if (filter.clientNames?.length > 0) {
        params.clientNames = filter.clientNames
    }
    if (filter.randomSampleEnabled) {
        params.randomSampleEnabled = true;
    }
    if (filter.randomSampleSize && filter.randomSampleSize >= 20 && filter.randomSampleSize <= 100) {
        params.randomSampleSize = filter.randomSampleSize;
    }
    const baseUrl = new URL(window.location.href);
    baseUrl.search = `filter=${toBase64(JSON.stringify(params))}`;
    return baseUrl.toString();
}
function toBase64(str) {
    const bin = new TextEncoder().encode(str);
    let b64 = btoa(String.fromCharCode(...bin));
    return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/,'');
}

function fromBase64(b64url) {
    let b64 = b64url.replace(/-/g, '+').replace(/_/g, '/');
    while (b64.length % 4) b64 += '=';
    const bin = atob(b64);
    return new TextDecoder().decode(Uint8Array.from(bin, c => c.charCodeAt(0)));
}
